import 'leaflet';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';

export class ZoomLayer {
  name: string;
  call: (bounds: L.LatLngBounds) => Observable<GeoJSON.FeatureCollection<any>>;
  lastCall: Subscription;
  lastBounds: L.LatLngBounds;
  layer: L.GeoJSON;
  features: GeoJSON.FeatureCollection<any>;
  zoomLevel: number;
}



// WEBPACK FOOTER //
// ./src/app/models/zoomlayer.ts